import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE } from '../api-base.token';
import { IntegrationRequest } from './integration-request';
import { IntegrationResponse } from './integration-response';

const path = 'integrations';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, `${path}`);

    return this.httpClient.get<IntegrationResponse[]>(url);
  }

  getEventCodes() {
    const url = Location.joinWithSlash(this.apiBase, `${path}/event-codes`);

    return this.httpClient.get<string[]>(url);
  }

  create(request: IntegrationRequest) {
    const url = Location.joinWithSlash(this.apiBase, `${path}`);

    return this.httpClient.post(url, request);
  }

  delete(integrationId: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${integrationId}`
    );

    return this.httpClient.delete(url);
  }
}
